export const enrolledStatuses = [
  "api_unenrolled",
  "unenrolled",
  "enrolled",
  "pending_revivn_unenrollment_confirmation",
  "not_found",
];
